module.exports = __webpack_public_path__ + "TROLLER-logo.png";